import React from 'react';
/* import './Home.css'; */

const Footer = () => {
  return (
    <div className="mainHome-container">
    
    <section className="product-categories" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Our Product Categories</h2>
      <p>Explore our diverse range of products across multiple industries</p>
      <button className="view-button">View All Products</button>
      <h2 className='Product-category-title'>Browse by Category</h2>
    </section>
    
    </div>
  );
};

export default Footer;

